export class ListUserAnswersDTO {

    questions!: {
        id: number
        answers: string[]
    }[]

}